import matches from './matches';

/**
 * Return ancestor or self that matches `selectors`.
 *
 * @param {any} el
 * @param {string} selectors
 */
export default function ancestorOrSelf(el, selectors) {
    if (el == null) {
        return null;
    }

    return matches(el, selectors) ? el : ancestorOrSelf(el.parentElement, selectors);
}
